import { Component, Input } from '@angular/core';
import { HomePlaceholderComponent } from './home/home-placeholder.component';
import { IntroExpPlaceholderComponent } from './header/introexp-placeholder.component';
import { WelcomePlaceholderComponent } from './welcome/welcome-placeholder.component';
import { MyLearningPlaceholderComponent } from './my-learning/my-learning-placeholder.component';
import { NewsPlaceholderComponent } from './news/news-placeholder.component';
import { SkeletonComponent } from '@esolutions/design-system-ng/components';
import { FeaturedPlaceholderComponent } from './featured/featured-placeholder.component';

@Component({
  selector: 'app-placeholder',
  templateUrl: './placeholder.component.html',
  styleUrls: ['./placeholder.component.scss'],
  imports: [
    HomePlaceholderComponent,
    IntroExpPlaceholderComponent,
    WelcomePlaceholderComponent,
    MyLearningPlaceholderComponent,
    NewsPlaceholderComponent,
    SkeletonComponent,
    FeaturedPlaceholderComponent
  ],
  standalone: true
})

/**
 * Component will be created by the placeholder directive
 * (src/app/shared/directives/placeholder.directive.ts)
 *
 * Building block of the components are in Design System placeholder components:
 * https://ucd.deakin.edu.au/components-ref/?path=/story/global-components-placeholder--playground
 */
export class PlaceholderComponent {
  @Input()
  placeholder = '';
}
